import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { Box, CssBaseline } from '@mui/material';
import theme from './theme';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
import ScrollToTop from './components/ScrollToTop';
import { captureTrafficSource, trackEvent } from './utils/analytics';
import Home from './pages/Home';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import Platform from './pages/Platform';
import DemoReport from './pages/DemoReport';
import DemoSimulation from './pages/DemoSimulation';
import About from './pages/About';
import Contact from './pages/Contact';
import QuoteRequest from './pages/QuoteRequest';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import Careers from './pages/Careers';
import NotFound from './pages/NotFound';

function PageTracker() {
  const location = useLocation();

  // Capture traffic source once on first load
  useEffect(() => {
    const consent = localStorage.getItem('inspectiq_cookie_consent');
    if (consent === 'denied') return;
    const src = captureTrafficSource();
    trackEvent('traffic_source', {
      source: src.source || 'direct',
      medium: src.medium || 'none',
      campaign: src.campaign || '',
    });
  }, []);

  useEffect(() => {
    const consent = localStorage.getItem('inspectiq_cookie_consent');
    if (consent === 'denied') return; // Don't track if denied

    // Defer so react-helmet-async has updated document.title for this route
    const timer = setTimeout(() => {
      if (window.gtag) {
        window.gtag('event', 'page_view', {
          page_path: location.pathname + location.search,
          page_location: window.location.href,
          page_title: document.title,
        });
      }
    }, 50);

    return () => clearTimeout(timer);
  }, [location]);

  return null;
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <PageTracker />
        <ScrollToTop />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
            backgroundColor: 'background.default',
          }}
        >
          <Navbar />
          <Box sx={{ flexGrow: 1, pt: { xs: '64px', md: '70px' } }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="/platform" element={<Platform />} />
              <Route path="/platform/demo-report" element={<DemoReport />} />
              <Route path="/platform/demo" element={<DemoSimulation />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/quote" element={<QuoteRequest />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Box>
          <Footer />
        </Box>
        <CookieConsent />
      </Router>
    </ThemeProvider>
  );
}

export default App;